// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cvent-landing-page-banner-container {
  background: linear-gradient(180deg, #9cffc3 0%, #65c09f 100%);
}
`, "",{"version":3,"sources":["webpack://./src/pages/landingPage/banner/cventMobileBanner/style.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;AAC/D","sourcesContent":[".cvent-landing-page-banner-container {\n  background: linear-gradient(180deg, #9cffc3 0%, #65c09f 100%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
